<template>
  <div class="footer-tips">
    <img src="@/assets/image/icon/create.png" />
  </div>
</template>

<style lang="less" scoped>
.footer-tips {
  margin: 20px auto 20px;
  text-align: center;
  img {
    width: 136px;
    height: 18px;
  }
}
</style>
